import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';

export const AuditLog = {
    storeAuditLogs
};

function getuserId() {
    return localStorage.getItem("userId");
}

async function storeAuditLogs(requestBody, type) {
    const request = JSON.stringify(requestBody);
    return await axiosInstance.post(API_HOST + "/auditlogs/" + type + "/" + getuserId(), request, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        })
        .catch(error => {
            return error;
        });
}